export enum ShowBehavior {
  All = 1,
  DirectDecendants,
  AllDecendants
}